export default ({ i18n }) => ({
  ASSIGN_TEXT: i18n.t`Assign`,
  ASSIGN_BUTTON_TEXT: (assignAssignmentCount) => `${i18n.t`Assign`} (${assignAssignmentCount})`,
  UNASSIGN_TEXT: i18n.t`Unassign`,
  UNASSIGN_BUTTON_TEXT: (unassignAssignmentCount) => `${i18n.t`Unassign`} (${unassignAssignmentCount})`,
  CELL_SELECTED_TEXT: i18n.t`cell selected`,
  CELLS_SELECTED_TEXT: i18n.t`cells selected`,
  ASSIGN_NO_DUE_DATE_TEXT: i18n.t`Assign with no due date`,
  ASSIGN_LATER_TEXT: i18n.t`Assign later`,
  MODIFY_ASSIGN_DATES_TEXT: i18n.t`Modify assign dates`,
  ASSIGN_NOW_TEXT: i18n.t`Assign Now`,
  UNASSIGN_POPUP_TEXT: i18n.t`Selected student Quests`,
  UNASSIGN_ALL_TEXT: i18n.t`Unassign All`,
  UNASSIGN_ALL_CONFIRMATION_TEXT: i18n.t`Unassign All - Confirmation`,
  UNASSIGN_ALL_POPUP_TEXT: i18n.t`Everything for this class and group`,
  UNASSIGN_MODAL_HEADER_TEXT: i18n.t`Unassign all?`,
  UNASSIGN_MODAL_CONTENT_TEXT: i18n.t`Unassign.modal.content`,
  UNASSIGN_MODAL_SUBMIT_TEXT: i18n.t`submit`
});



// WEBPACK FOOTER //
// ./components/footer/translations.js